import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthenticationService } from '@core/services/authentication.serivce';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { RedeploymentOrdersRoutingModule } from './redeployment-orders-routing.module';
import { RedeploymentOrderListComponent } from './redeployment-order-list/redeployment-order-list.component';
import { RedeploymentOrderService } from './services/redeployment-order.service';
import { RedeploymentOrderComponent } from './redeployment-order/redeployment-order.component';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { DetailLayoutComponent } from '../../shared/components/detail-layout/detail-layout.component';
import { GridKendoCardComponent } from '../../shared/components/grid-kendo-card/grid-kendo-card.component';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { AddItemsComponent } from './add-items/add-items.component';
import { RemoveItemsComponent } from './remove-items/remove-items.component';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ReassignItemsComponent } from './reassign-items/reassign-items.component';


@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ButtonModule,
    LayoutModule,
    TextBoxModule,
    TextAreaModule,
    GridModule,
    GridLayoutModule,
    CheckBoxModule,
    NumericTextBoxModule,
    LabelModule,
    GridLayoutModule,
    GridModule,
    NotificationModule,
    BreadCrumbModule,
    DialogModule,
    InputsModule,
    DetailLayoutComponent,
    GridKendoCardComponent,
    SelectFieldComponent,
    DetailComponent,
    SearchComponent,
    SharedModule,
    TabStripModule,
    ContextMenuModule,
    RedeploymentOrdersRoutingModule,
    LoaderModule,
    FaIconComponent
  ],
  declarations: [
    RedeploymentOrderListComponent,
    RedeploymentOrderComponent,
    AddItemsComponent,
    RemoveItemsComponent,
    ReassignItemsComponent
  ],
  providers: [AuthenticationService, RedeploymentOrderService]
})
export class RedeploymentOrdersModule { }
